export * from './Skeleton';
//# sourceMappingURL=index.js.map